import React from 'react';
import Flashcard from '../../components/Flashcard';

const FlashcardContainer = ({ 
  cards, 
  currentCardIndex, 
  selectedCertification, 
  onNext, 
  onPrevious 
}) => {
  return (
    <div className="flashcard-container">
      <Flashcard
        card={cards[currentCardIndex]}
        onNext={onNext}
        onPrevious={onPrevious}
        currentIndex={currentCardIndex}
        totalCards={cards.length}
      />
      <div className="progress-bar">
        <div 
          className="progress-fill" 
          style={{ 
            width: `${((currentCardIndex + 1) / cards.length) * 100}%`,
            backgroundColor: selectedCertification.color 
          }}
        ></div>
      </div>
    </div>
  );
};

export default FlashcardContainer;
